import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { ProductionPlanActions } from "redux/actions";
interface IProductionPlanState extends IBaseReducerState {}

const initialState: IProductionPlanState = {
  action: ProductionPlanActions.prefix,
  prefix: ProductionPlanActions.prefix,
};

const clearReducer = (state: IProductionPlanState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = ProductionPlanActions.prefix;
  });

const reducer = ReduxHelper.createHandleReducer(initialState, (builder) => {
  builder.addCase(ProductionPlanActions.clearReducer.request, clearReducer);
});

export default reducer;
